const SPECIALITY_DRUGS_MESSAGES = {
  PAGE_HEADINGS: {
    TITLE: 'Speciality Drugs',
    SUB_TITLE:
      'Metrics on pharmacy spend and the drug types with the highest plan impact.',
  },
  OVERVIEW_CARDS: {
    MEMBERS: 'Cohort Members',
    COST: 'Cohort Cost',
    PMPM: 'Cohort PMPM',
    PEPM: 'Cohort PEPM',
  },
  DRUG_CATEGORIES_CHART: {
    TITLE: 'Drug categories of Non Cancer',
  },
  BREADCRUMB: 'Speciality Drugs',
  DRUGS_TABLE: 'Speciality Drug Details',
  DRUGS_TABLE_SUBTITLE: 'View the details of speciality drugs',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  NO_DATA_DRUGS: 'No Drugs Available',
};

export default SPECIALITY_DRUGS_MESSAGES;
